import script from "./motivations.vue?vue&type=script&setup=true&lang=js"
export * from "./motivations.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__